import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const CGVPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-foreground p-4 md:p-8">
      <div className="max-w-3xl mx-auto">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6 text-muted-foreground hover:text-foreground"
          data-testid="back-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Button>

        <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ color: '#1E40AF' }}>
          Conditions Générales de Vente
        </h1>

        <div className="space-y-8 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">1. Préambule</h2>
            <p>Les présentes CGV régissent les relations contractuelles entre ZANATTA CONSULTING (SARL, SIRET 850 771 452 00024), éditeur de l'application DevisFast, et tout client souscrivant à un abonnement payant au Service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">2. Identification du vendeur</h2>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Raison sociale : ZANATTA CONSULTING</li>
              <li>Forme juridique : SARL (Société à Responsabilité Limitée)</li>
              <li>Capital social : 1 666 000,00 €</li>
              <li>Siège social : 9 Clos de Poumarol, 31320 Aureville</li>
              <li>SIRET : 850 771 452 00024</li>
              <li>RCS : 850 771 452 R.C.S. Toulouse</li>
              <li>N° TVA : FR25850771452</li>
              <li>Email : support@devisfast.fr</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">3. Description de l'offre</h2>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">3.1 Essai gratuit</h3>
            <p>Tout nouvel utilisateur bénéficie d'une période d'essai gratuite de 14 jours, sans engagement et sans saisie de coordonnées bancaires.</p>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">3.2 Abonnement payant</h3>
            <p>À l'issue de la période d'essai, l'accès au Service est conditionné à la souscription d'un abonnement payant. Deux formules sont disponibles : <strong className="text-foreground">9,99 € TTC par mois</strong> (renouvellement mensuel automatique) ou <strong className="text-foreground">89 € TTC par an</strong> (renouvellement annuel automatique).</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">4. Prix et TVA</h2>
            <p>Tous les prix sont indiqués en euros TTC. La TVA applicable est celle en vigueur au jour de la commande.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">5. Commande et souscription</h2>
            <p>La souscription s'effectue depuis l'interface de l'application via la plateforme sécurisée Stripe. La confirmation de commande est envoyée par email à l'adresse renseignée lors de l'inscription.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">6. Paiement</h2>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">6.1 Modalités</h3>
            <p>Le paiement s'effectue par carte bancaire (Visa, Mastercard, etc.) via Stripe. Les coordonnées bancaires ne sont pas stockées par DevisFast.</p>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">6.2 Renouvellement automatique</h3>
            <p>L'abonnement est renouvelé automatiquement à chaque échéance (mensuelle ou annuelle selon la formule choisie lors de la souscription).</p>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">6.3 Échec de paiement</h3>
            <p>En cas d'échec de paiement, le client sera notifié par email. L'accès au Service pourra être suspendu jusqu'à régularisation.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">7. Droit de rétractation</h2>
            <p>Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux contrats de fourniture de contenu numérique dont l'exécution a commencé avec l'accord préalable exprès du consommateur. Toutefois, si l'utilisateur n'a pas encore utilisé le Service après souscription, il peut contacter le support dans les 14 jours pour demander un remboursement, qui sera examiné au cas par cas.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">8. Résiliation</h2>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">8.1 Par le client</h3>
            <p>Le client peut résilier à tout moment depuis son espace personnel (Abonnement {">"} Gérer mon abonnement). La résiliation prend effet à la fin de la période en cours. Aucun remboursement prorata temporis ne sera effectué.</p>
            
            <h3 className="text-lg font-medium text-foreground/90 mt-4 mb-2">8.2 Par DevisFast</h3>
            <p>ZANATTA CONSULTING se réserve le droit de suspendre ou résilier l'accès au Service en cas de non-respect des CGU ou des CGV, après mise en demeure restée sans effet.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">9. Données personnelles</h2>
            <p>Les données collectées lors de la commande sont utilisées exclusivement pour la gestion de la relation commerciale. Conformément au RGPD, le client dispose d'un droit d'accès, rectification et suppression de ses données en contactant : support@devisfast.fr</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">10. Responsabilité</h2>
            <p>ZANATTA CONSULTING s'engage à mettre en œuvre tous les moyens raisonnables pour assurer la disponibilité du Service. Sa responsabilité est limitée au montant des sommes versées par le client au cours des 3 derniers mois précédant le fait générateur.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">11. Médiation</h2>
            <p>En cas de litige non résolu amiablement, le client peut recourir à la médiation de la consommation. Coordonnées du médiateur disponibles sur simple demande à : support@devisfast.fr</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">12. Droit applicable</h2>
            <p>Les présentes CGV sont soumises au droit français. Tout litige relève de la compétence des tribunaux du ressort de Toulouse.</p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-border text-center text-sm text-muted-foreground">
          Dernière mise à jour : 04/05/2026
        </div>
      </div>
    </div>
  );
};

export default CGVPage;
